export default __webpack_public_path__ + "media/header3x.3c6daf34.png";